import React, { useEffect } from 'react';
import { Section as SectionDI } from '@atlaskit/side-navigation';
import { MenuItem as MenuItemDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { matchUrlPathname as matchUrlPathnameDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { useReportsNavApi as useReportsNavApiDI } from '@atlassian/jira-servicedesk-reports-nav-api/src/index.tsx';
import { useCustomReports as useCustomReportDI } from '../../../../controllers/custom-reports/index.tsx';
import type { JsdReportsProps } from './types.tsx';

export const JsdReports = ({
	MenuItem = MenuItemDI,
	Section = SectionDI,
	matchUrlPathname = matchUrlPathnameDI,
	title,
	useCustomReport = useCustomReportDI,
	useReportsNavApi = useReportsNavApiDI,
}: JsdReportsProps) => {
	const { data: initialCustomReportsFromSidebarConfig } = useCustomReport();
	const [
		{
			data: { customReports },
		},
		actions,
	] = useReportsNavApi();

	// on mount, we need to use custom reports data from sidebar nav to populate the dedicated jsd report store
	useEffect(() => {
		if (initialCustomReportsFromSidebarConfig) {
			actions.setItems({ customReports: initialCustomReportsFromSidebarConfig });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Section title={title}>
			{customReports.map((item) => (
				<MenuItem
					analytics={{ itemId: item.id }}
					key={item.id}
					href={__SPA__ ? item.url.replace(/^\/projects/, '/jira/servicedesk/projects') : item.url}
					selectedOn={matchUrlPathname()}
				>
					{item.name}
				</MenuItem>
			))}
		</Section>
	);
};
